export const ENDPOINT_EMAIL_FIND_ALL = '/api/faq/list';
export const ENDPOINT_EMAIL_FIND_ONE = '/api/faq/get-one';
export const ENDPOINT_EMAIL_CREATE_ONE = '/api/faq/create';
export const ENDPOINT_EMAIL_DELETE_ONE = '/api/faq/delete';
export const ENDPOINT_EMAIL_UPDATE_ONE = '/api/faq/update';
